import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_GenerateShareableLink = {
  shareable_link: string;
  short_code: string;
  expires_at?: string;
};

export type ApiRequest_GenerateShareableLink = {
  community_id: Id;
  negotiation_id: Id;
  expires_at?: string;
};

const METHOD = 'POST';
const ENDPOINT = 'negotiation/shareable-link';

export const useGenerateShareableLink = (
  stateFns?: MutationStateFns<ApiResponse_GenerateShareableLink>
) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: ApiRequest_GenerateShareableLink) =>
      handleApiCall<ApiResponse_GenerateShareableLink, ApiRequest_GenerateShareableLink>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {}),
        data
      ),
    onSuccess: data => {
      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      // Error already handled by enqueueSnackbar
      stateFns?.onError?.(err);
    },
  });
};
